import React, { FC } from 'react';
import { Link, Outlet } from 'react-router-dom';
import useWindowsDimension from 'functions/useWindowsDimension';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

/**
 * Setup navigation layout for application settings.
 */
export const Setup: FC = () => {
  const { t } = useTranslation();
  const { width } = useWindowsDimension();
  const drawerWidth: number = 250;
  let teller: number = -1;

  // Navigation items
  const navItems = [
    { to: 'mainCompany', label: t('Settings.SetupNav.CompanyDetails') },
    { to: 'employees', label: t('Settings.SetupNav.EmployeeRoles') },
    { to: 'productData', label: t('Settings.SetupNav.ProductDataSetup') },
    { to: 'workRoles', label: t('Settings.SetupNav.EconomySetup') },
    { to: 'autoAnswers', label: t('Settings.SetupNav.AutoAnswers') },
    { to: 'brand', label: t('Settings.SetupNav.Brand') },
    { to: 'defaultSettings', label: t('Settings.SetupNav.DefaultValuesSetup') },
    { to: 'budget', label: t('Settings.SetupNav.Budget') },
  ];

  return (
    <Grid container display="flex" direction="row" spacing={0}>
      <Grid item xs={2} sx={{ pr: 0.5 }}>
        <Paper
          variant="elevation3"
          sx={{
            borderRadius: 3,
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
          }}
        >
          <List sx={{ color: 'primary.text' }}>
            {navItems.map((item) => (
              <ListItem
                button
                component={Link}
                to={`/Setup/${item.to}`}
                key={teller++}
              >
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Grid>

      <Grid item xs={10} sx={{ pl: 0.5 }}>
        <Paper
          variant="elevation3"
          sx={{
            p: 2,
            height: Math.ceil(useWindowsDimension().height - 64),
          }}
        >
          <Outlet />
        </Paper>
      </Grid>
    </Grid>
  );
};
